import { Component, OnInit } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbIconModule } from '@nebular/theme';
import { RobotFamilyMetadata } from 'src/app/models/robot-family-metadata';
import { CustomValueHandlingPipe } from 'src/app/shared/pipes/custom-value-handling.pipe';
import { TimestampDatePipe } from 'src/app/shared/pipes/timestamp-date.pipe';
import { MetadataTableCellComponent } from 'src/app/shared/ui/metadata-table-cell/metadata-table-cell.component';

@Component({
  selector: 'app-view-robot-family-metadata',
  templateUrl: './view-robot-family-metadata.component.html',
  styleUrls: ['./view-robot-family-metadata.component.css'],
  providers: [TimestampDatePipe],
  imports: [NbCardModule, NbIconModule, NbButtonModule, CustomValueHandlingPipe, MetadataTableCellComponent],
  standalone: true
})
export class ViewRobotFamilyMetadataComponent implements OnInit {
  public metadata!: RobotFamilyMetadata;

  public localeDisplays: string[] = [];

  public formatted_created_time = '';
  public formatted_updated_date = '';

  constructor(
    protected ref: NbDialogRef<ViewRobotFamilyMetadataComponent>,
    private formatDatePipe: TimestampDatePipe
  ) {}

  public ngOnInit() {
    this.handleDate();
  }

  public formatDate = (time: number | undefined) => {
    const formatted_time = this.formatDatePipe.transform(time, 'timestampToDate');
    if (formatted_time) {
      return formatted_time;
    } else {
      return '';
    }
  };

  public handleDate() {
    const created_date = this.metadata.created_dttm;
    this.formatted_created_time = this.formatDate(created_date);

    const updated_date = this.metadata.last_updated_dttm;
    this.formatted_updated_date = this.formatDate(updated_date);
  }

  public close() {
    this.ref.close();
  }
}
